// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  users: 'admins',

  firebase: {
    apiKey: "AIzaSyBN__iB9P8RcvOcCtmPS_1IrfEUljNtRRw",
    authDomain: "mensajeros-dev.firebaseapp.com",
    databaseURL: "https://mensajeros-dev.firebaseio.com",
    projectId: "mensajeros-dev",
    storageBucket: "mensajeros-dev.appspot.com",
    messagingSenderId: "555753970667"
  },

  googleMapsKey: 'AIzaSyCHQYM3jOJcpnzId3wbnvT6tKYS4bgLrGc',

  debug: true,
  log: {
    auth: true,
    store: true,
  },

  smartadmin: {
    api: null,
    db: 'mensajeros-ec'
  }

  
};
